export enum vitalParametersSpecialValues {
  notMeasurable = -1,
  high = -2,
  low = -3,
  notMeasured = -4,
}
